import { useUserStore } from '@/store/userStore'
import { useEffect } from 'react'

export const useUser = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    updateUser,
    clearUser,
    getUserFromStorage,
    isUserLoggedIn,
  } = useUserStore()

  // Initialize the store on first load - verify session with backend
  useEffect(() => {
    const user = getUserFromStorage()
    
    if (user && !isAuthenticated) {
      // User data exists, verify session with backend
      useUserStore.getState().verifySession()
    } else if (!user && isAuthenticated) {
      // No user data but authenticated state is true, clear it
      useUserStore.getState().clearUser()
    }
  }, [isAuthenticated, getUserFromStorage])

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    updateUser,
    clearUser,
    getUserFromStorage,
    isUserLoggedIn,
  }
}

// Export the user store for direct access when needed
export { useUserStore } from '@/store/userStore'
export type { User } from '@/store/userStore' 